import { CenteredCard } from '../../components/centered.card/centered.card';
import { IMithrilComponent } from '../../components/mithril.component';
import { addStyles } from '../../components/theme';
import { DefaultTheme } from '../../components/theme';
import type { MithrilVNode } from '../../mithril';
import { UserSelfMigrate } from '../../modules/auth/migrate.user';
import { IkePage, type IkePageConfig, IkePageName } from '../page';

const CSS = {
	container: 'c-MigratePage__container',
	card: 'c-MigratePage__Card',
	button: 'c-MigratePage__action',
	padding: 'c-MigratePage__spacing',
	centered: 'c-MigratePage_centered',
};

const Style = {
	[CSS.padding]: {
		paddingTop: DefaultTheme.space(6),
	},

	[CSS.button]: {
		width: '100%',
	},

	[CSS.container]: {
		width: '100%',
		height: `calc(100vh - ${DefaultTheme.space(6)})`,
		paddingTop: DefaultTheme.space(6),
	},

	[CSS.centered]: {
		transform: 'translateX(50vw) translateY(50vh)',
		marginLeft: '-12px',
		marginTop: '-12px',
	},
};

addStyles(Style);

export const SSOMigratePageConfig: IkePageConfig = {
	type: 'internal',
	name: IkePageName.userSSOMigrate,
	path: '/auth/migrate',
	auth: { required: false },
	layout: { nav: false, banner: false },
};

export class SSOMigratePage extends IkePage {
	name = 'SSOMigratePage';

	private component: IMithrilComponent;

	constructor() {
		super(SSOMigratePageConfig);
		this.component = new UserSelfMigrate();
	}

	get nodes(): MithrilVNode {
		return CenteredCard.view(this.component.view(), { className: CSS.card });
	}
}
